import { GTMolecularExportFn } from "../../components/GTMolecularExportFn";

const FN_NAME = "gtm-export-rerun-requests";

function FnRun() {
  return <GTMolecularExportFn name={FN_NAME} />;
}

export { FnRun };
